angular.module('bmsApp.resource', [])
	.config([
		'$stateProvider',
		function config($stateProvider) {

			var indexViews = {
				'main@main': {
					templateUrl: 'ng/resource/templates/ResourceIndex.html',
					controller: 'ResourceIndexCtrl',
					controllerAs: 'Index'
				}
			};

			$stateProvider

				.state('main.resource', {
					abstract: true
				})

				.state('main.resource.myFiles', {
					url: '^/resources/my-files?directory',
					views: indexViews,
					resolve: {
						group: function () {
							return 'my_files';
						}
					},
					ncyBreadcrumb: {
						label: "My Files{{ Index.currentDir.label ? (' - ' + Index.currentDir.label) : '' }}"
					}
				})

				.state('main.resource.sharedWithMe', {
					url: '^/resources/shared-with-me?directory',
					views: indexViews,
					resolve: {
						group: function () {
							return 'shared_with_me';
						}
					},
					ncyBreadcrumb: {
						label: "Shared With Me{{ Index.currentDir.label ? (' - ' + Index.currentDir.label) : '' }}"
					}
				})

				.state('main.resource.read', {
					url: '^/resource/{resourceId}',
					views: {
						'main@main': {
							templateUrl: 'ng/resource/templates/ResourceRead.html',
							controller: 'ResourceReadCtrl',
							controllerAs: 'Read'
						}
					},
					ncyBreadcrumb: {
						label: "Resources - {{ Read.resource.file.label }}"
					}
				})

			;

		}
	]);
